module.exports = __webpack_public_path__ + "static/media/coding1.d63e4410.jpg";